function goEdit() {
  $(".have-profile").hide();
  $(".no-profile").show();
}

let stopClickSubmit = false; //阻止二次点击事件
function goSave() {
  let firstName_info = document.getElementById("edit-first-name").value;
  let lastName_info = document.getElementById("edit-last-name").value;
  let store_info = document.querySelector(".store-type .type-title").textContent;
  let shopName_info = document.getElementById("edit-shop-name").value;
  let business_info = document.getElementById("edit-business-name").value;
  let abn_info = document.getElementById("edit-abn-number").value;
  let website_info = document.getElementById("edit-website-name").value;
  let country_info = document.querySelector(".country-code .type-title").textContent;
  let zip_info = document.getElementById("edit-zip-code").value;
  let phone_info = document.getElementById("edit-phone").value;
  let city_info = document.getElementById("edit-city-name").value;
  let addressOne_info = document.getElementById("edit-address-one").value;
  let addressTwo_info = document.getElementById("edit-address-two").value;
  let source_info = document.querySelector(".source-type .type-title").textContent;
  var proNum = document.querySelector(".profile-content .iti__selected-flag");
  var proNumCode = document.querySelector(
    ".profile-content .iti__selected-dial-code"
  ).innerText;

  if (proNum) {
    var proCountry = proNum.getAttribute("aria-activedescendant"); //国家编码
    if (proCountry.includes('-preferred')) {
      proCountry = proCountry.replace('-preferred', '').slice(-2);
    } else {
      proCountry = proCountry.slice(-2);
    }
    localStorage.setItem("proCountry", proCountry);
  }

  var editInfo = {
    shop_id: shopIdAuth,
    first_name: firstName_info,
    last_name: lastName_info,
    phone_number_code: proNumCode,
    phone_number: phone_info,
    store_type: store_info == 'Online Only' ? 1 : store_info == 'Retail Store Only' ? 2 : 3,
    shop_name: shopName_info,
    business_name: business_info,
    abn_number: abn_info,
    website: website_info,
    country: country_info,
    country_code: country_code,
    city: city_info,
    zip: zip_info,
    store_address: addressOne_info,
    store_address_expand: addressTwo_info || '-',
    about_us_source: source_info == 'INS' ? 1 : source_info == 'Facebook' ? 2 : source_info == 'Internet Search' 
    ? 3 : source_info == 'Friend' ? 4 : source_info == "I'm existing customer" ? 5 : 6,
  };

  const hasEmpty = Object.values(editInfo).some(item => item === "");

  if (hasEmpty) {
    showToastTips("Please fill in the required fields", "error");
    return; 
  }

  if(stopClickSubmit) return;
  stopClickSubmit = true;

  var profileEdit = `${heychic_api}/wholesale/customer/update`;
  fetch(profileEdit, {
    method: "POST", // 请求方法
    headers: {
      "Content-Type": "application/json", // 请求头，指明请求体格式为 JSON
      Authorization: authorization,
      "X-Shop-Id": shopIdAuth,
    },
    body: JSON.stringify(editInfo), // 请求体，转为 JSON 字符串
  })
    .then((response) => response.json()) // 处理响应并将其解析为 JSON
    .then((data) => {
      if (data.code == 200) {
        stopClickSubmit = false;
        $(".have-profile").show();
        $(".no-profile").hide();
        getProfile();
      } else {
        showToastTips(`${data.message}`, 'error');
      }
    }) // 处理返回的数据
    .catch((error) => {
      console.error("Error:", error)
      stopClickSubmit = false;
    }
  ); // 错误处理
}

// 居中的 带图标的toast
// toast每次点击清除定时器
var toastClick = false;
function showToastTips(message, type) {
  const toastTips = document.getElementById('toast-icon');
  const toastTextBox = toastTips.querySelector('.toast-text');
  const toastImage = toastTips.querySelector(`.icon-${type}`);
  toastTextBox.textContent = message;
  toastImage.style.display = 'block';
  toastTips.style.display = 'flex';
  toastTips.style.opacity = 1;

  if(toastClick) {
    clearTimeout(toastTimer);
  };
  toastClick = true;
  toastTimer = setTimeout(function() {
    toastTips.style.opacity = 0;
    setTimeout(function() {
      toastTips.style.display = 'none';
      toastImage.style.display = 'none';
    }, 500);
  }, 1500);
}

// 个人信息详情
function getProfile() {
  var profileInfo = `${heychic_api}/wholesale/customer/info`;
  fetchRequest(profileInfo, "GET")
    .then((data) => {
      if (data.code == 200 && data.data) {
        const customerEmail = window.customerEmail;
        // 默认头像'
        if (data.data?.head_image) {
          $('.logoHeader_person').html(`<img src='${data.data?.head_image}' alt=""/>`);
        } else {
          $('.logoHeader_person').html(`
          <div class="staticImg">
          ${data.data.email ? data.data.email.charAt(0) : customerEmail ? customerEmail.charAt(0) : ''}
          </div>`);
        }

        $(".info-first-name").text(data.data.first_name || '-');
        $(".info-last-name").text(data.data.last_name || '-');
        $(".info-email-address").text(data.data.email || '-');
        $(".info-store-type").text(
          data.data.store_type == 1 ? "Online Only" :
            data.data.store_type == 2 ? "Retail Store"
              : data.data.store_type == 3 ? "Both" : "-"
        );
        $(".info-shop-name").text(data.data.shop_name || "-");
        $(".info-business-name").text(data.data.business_name || "-");
        $(".info-abn-number").text(data.data.abn_number || '-');
        $(".info-website-name").text(data.data.website || '-');
        $(".info-country-name").text(data.data.country || '-');
        $(".info-city-name").text(data.data.city || '-');
        $(".info-zip-name").text(data.data.zip || '-');
        $(".info-phone").text(data.data.phone_number_code + data.data.phone_number || '-');
        $(".info-address-one").text(data.data.store_address || '-');
        $(".info-address-two").text(data.data.store_address_expand || '-');
        $(".info-source").text(
          data.data.about_us_source == 1 ? "INS" :
            data.data.about_us_source == 2 ? "Facebook"
              : data.data.about_us_source == 3 ? "Internet Search" :
                data.data.about_us_source == 4 ? "Friend"
                  : data.data.about_us_source == 5 ? "I'm existing customer" : data.data.about_us_source == 6 ? "Other" : "-"
        );

        localStorage.setItem("proCountry", data.data.phone_country);
        localStorage.setItem("birthday", data.data.birthday);


        // 编辑
       $("#edit-first-name").val(data.data.first_name);
        $("#edit-last-name").val(data.data.last_name);
        $("#edit-email-name").val(data.data.email);
        $(".store-type .type-title").text(
          data.data.store_type == 1 ? "Online Only" :
            data.data.store_type == 2 ? "Retail Store"
              : data.data.store_type == 3 ? "Both" : ""
        );
        $(".store-type .type-title").addClass("active");
        $("#edit-shop-name").val(data.data.shop_name);
        $("#edit-business-name").val(data.data.business_name);
        $("#edit-abn-number").val(data.data.abn_number);
        $("#edit-website-name").val(data.data.website);
        $(".country-code .type-title").text(data.data.country);
        $(".country-code .type-title").addClass("active");
        $("#edit-city-name").val(data.data.city);
        $("#edit-zip-code").val(data.data.zip);
        $("#edit-phone").val( data.data.phone_number);
        $("#edit-address-one").val(data.data.store_address);
        $("#edit-address-two").val(data.data.store_address_expand);
        $(".source-type .type-title").text(
          data.data.about_us_source == 1 ? "INS" :
            data.data.about_us_source == 2 ? "Facebook"
              : data.data.about_us_source == 3 ? "Internet Search" :
                data.data.about_us_source == 4 ? "Friend"
                  : data.data.about_us_source == 5 ? "I'm existing customer" : data.data.about_us_source == 6 ? "Other" : ""
        );
        $(".source-type .type-title").addClass("active");
      }
      if(data.code == 401 || data.code == 404){
            deleteAllCookies();
            window.location.href = '/account/logout'; 
        } 
    })
    .catch((error) => console.error("Error fetching data:", error));
}
